export type FlowResult = {
    success: boolean;
    intentId?: string;
    paymentMethodId?: string;
    subscriptionId?: string;
    status?: string;
    error?: string;
};

export const extractErrorMessage = (e: unknown): string => {
    if (e instanceof Error) return e.message;
    if (typeof e === 'string') return e;
    if (e && typeof e === 'object') {
        const err = e as Record<string, unknown>;
        if (Array.isArray(err.errors) && err.errors.length > 0) {
            return err.errors.map((x: { message?: string }) => x.message || 'Unknown error').join('; ');
        }
        if (typeof err.message === 'string') return err.message;
        return JSON.stringify(e);
    }
    return 'Unknown error';
};
